import { useState, useEffect, useRef } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { IMaskInput } from "react-imask";
import { TIPO_DOCUMENTO } from "../../Utils";
import { RncLookup } from "../Lookups/RncLookup";
export const DocumentInput = ({
                                  initialValue = { value: "", type: "C" },
                                  onChange,
                                  defaultType = "C",
                                  posicionCanvas,
                              }) => {
    const refInput = useRef(null);
    const [document, setDocument] = useState({ value: "", type: defaultType });
    const [isInit, setIsInit] = useState(false);

    useEffect(() => {
        if (
            document.value !== undefined &&
            document.value &&
            document.value != ""
        ) {
            onChange(document);
        }
    }, [document]);

    useEffect(() => {
        if (
            initialValue.value &&
            initialValue.value != "" &&
            initialValue.value !== document.value
        ) {
            setDocument(initialValue);
        }
    }, [initialValue.value]);

    return (
        <>
            <InputGroup>
                <Form.Control
                    as="select"
                    name="Tipo"
                    value={document.type}
                    onChange={(e) =>
                        setDocument({
                            ...document,
                            type: e.target.value,
                        })
                    }
                    style={{
                        maxWidth: "30%",
                        minWidth: "25%",
                        borderRight: "1px solid #e3e3e3",
                    }}
                >
                    {Object.keys(TIPO_DOCUMENTO).map((docKey, idx) => {
                        return (
                            <option
                                key={`tipo-doc-${idx}`}
                                value={TIPO_DOCUMENTO[docKey].value}
                            >
                                {TIPO_DOCUMENTO[docKey].label}
                            </option>
                        );
                    })}
                </Form.Control>
                {document.type === TIPO_DOCUMENTO.CEDULA.value && (
                    <IMaskInput
                        mask={"000-0000000-0"}
                        unmask={false}
                        ref={refInput}
                        value={document.value}
                        onAccept={(_, mask) => {
                            setDocument({
                                ...document,
                                value: mask.unmaskedValue,
                            });
                        }}
                        placeholder="Cédula"
                        className="form-control"
                        style={{
                            width: "65%",
                        }}
                    />
                )}
                {document.type === TIPO_DOCUMENTO.PASAPORTE.value && (
                    <Form.Control
                        name="Documento"
                        placeholder="Pasaporte"
                        type="text"
                        value={document.value}
                        onChange={(e) =>
                            setDocument({
                                ...document,
                                value: e.target.value,
                            })
                        }
                        style={{
                            width: "65%",
                        }}
                    />
                )}
                {document.type === TIPO_DOCUMENTO.RNC.value && (
                    <RncLookup
                        placement={posicionCanvas}
                        isInput={true}
                        initialValue={{ value: document.value }}
                        onChange={(e) =>
                            setDocument({
                                ...document,
                                value: e.value,
                                ...e,
                            })
                        }
                    />
                )}
            </InputGroup>
        </>
    );
};
